"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizonWrapper = exports.HorizonElement = exports.HorizonContainer = exports.ImageCarousel = exports.Children = exports.Text = exports.Title = exports.StyledContainer = exports.Root = exports.horizonClasses = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const container_1 = __importDefault(require("../container"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "CarouselHero";
exports.classes = {
    slim: `${PREFIX}-slim`,
    carousel: `${PREFIX}-carousel`,
    keyline: `${PREFIX}-keyline`,
    spaceBottom: `${PREFIX}-spaceBottom`,
    spaceBottomLarge: `${PREFIX}-spaceBottomLarge`,
    wrapper: `${PREFIX}-wrapper`,
    content: `${PREFIX}-content`,
    cta: `${PREFIX}-cta`,
    controls: `${PREFIX}-controls`,
    image: `${PREFIX}-image`
};
exports.horizonClasses = {
    left: `${PREFIX}-left`,
    right: `${PREFIX}-right`
};
// These are not used by the horizon elements, but are used for padding out
// the other elements that are interacting with them.
// Calculated using ((7 * Math.PI) / 360) * deviceWidth, as the horizon elemnts
// need to have a 7 degree angle at all times.
const horizonHeightMd = "51.31268000863329";
const horizonHeightLg = "87.96459430051421";
const horizonHeightXl = "122.17304763960307";
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    flexDirection: "column",
    backgroundColor: theme.colours.white,
    color: theme.colours.charcoal,
    position: "relative",
    overflow: "hidden",
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        height: "auto"
    },
    [`&.${exports.classes.slim}`]: {
        [theme.breakpoints.up("md")]: {
            height: "auto",
            [`&:not(.${exports.classes.carousel}) .${exports.classes.wrapper}`]: {
                width: "auto"
            }
        },
        [`.${exports.classes.wrapper}`]: {
            paddingBottom: "8px"
        }
    },
    [`&.${exports.classes.carousel}`]: {
        [theme.breakpoints.up("md")]: {
            paddingBottom: "60px",
            [`.${exports.classes.content}`]: {
                paddingBottom: "32px"
            }
        },
        [theme.breakpoints.up("lg")]: {},
        [theme.breakpoints.up("xl")]: {
            [`.${exports.classes.content}`]: {
                paddingBottom: 0
            }
        }
    },
    [`&.${exports.classes.keyline}`]: {
        borderBottom: `12px solid ${theme.colours.accent}`
    },
    [`&.${exports.classes.spaceBottom}`]: {
        [theme.breakpoints.between("md", "xl")]: {
            paddingBottom: "140px",
            marginBottom: 0,
            [`.${exports.classes.controls}`]: {
                bottom: "124px"
            }
        },
        [theme.breakpoints.up("xl")]: {
            marginBottom: 0
        }
    },
    [`&.${exports.classes.spaceBottomLarge}`]: {
        [theme.breakpoints.between("md", "xl")]: {
            paddingBottom: "140px",
            marginBottom: "56px",
            [`.${exports.classes.controls}`]: {
                bottom: "124px"
            }
        },
        [theme.breakpoints.up("xl")]: {
            marginBottom: "56px"
        }
    },
    [`.${exports.classes.wrapper}`]: {
        display: "flex",
        width: "100%",
        minHeight: "auto",
        padding: "40px 0",
        flexDirection: "column",
        [theme.breakpoints.up("md")]: {
            width: "calc(50% + 12px)",
            height: "100%",
            padding: "24px 24px 40px 0"
        }
    },
    [`.${exports.classes.content}`]: {
        height: "100%",
        marginTop: "auto",
        marginBottom: "auto",
        [theme.breakpoints.up("md")]: {
            marginTop: "auto",
            marginBottom: "auto"
        },
        [theme.breakpoints.up("xl")]: {
            paddingBottom: 0
        }
    },
    [`.${exports.classes.cta}`]: {
        marginTop: "32px",
        display: "block",
        width: "fit-content",
        // NOTE: Fix the next slide being visible
        marginLeft: "1px"
    },
    [`.${exports.classes.controls}`]: {
        [theme.breakpoints.up("md")]: {
            zIndex: 3,
            right: "24px",
            bottom: "24px",
            margin: "24px 0 32px"
        },
        [theme.breakpoints.down("md")]: {
            margin: "32px 0"
        },
        [theme.breakpoints.up("xl")]: {
            position: "static"
        }
    }
}));
exports.StyledContainer = (0, styles_1.styled)(container_1.default)(({ theme }) => ({
    height: "100%",
    [theme.breakpoints.up("md")]: {
        marginBottom: `calc(80px + calc(${horizonHeightMd}px / 2))`
    },
    [theme.breakpoints.up("lg")]: {
        marginBottom: `calc(80px + calc(${horizonHeightLg}px / 2))`
    },
    [theme.breakpoints.up("xl")]: {
        marginBottom: `calc(80px + calc(${horizonHeightXl}px / 2))`
    }
}));
exports.Title = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    // NOTE: This gets rid of the next line high characters
    lineHeight: 1.2,
    "&::after": {
        // NOTE: Fix the next slide being visible
        marginLeft: "1px"
    },
    "&>svg": {
        display: "block",
        marginBottom: "24px"
    },
    // NOTE: none of the headers are truncated on mobile
    [theme.breakpoints.up("md")]: {
        WebkitLineClamp: 2
    }
}));
exports.Text = (0, styles_1.styled)(typography_1.default)(({ theme }) => ({
    minHeight: "auto",
    width: "100%",
    fontSize: "18px",
    lineHeight: 1.4,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    [theme.breakpoints.up("md")]: {
        fontSize: "20.25px"
    }
}));
exports.Children = (0, styles_1.styled)("div")(({ theme }) => ({
    zIndex: 1,
    [theme.breakpoints.up("lg")]: {
        maxWidth: "566px"
    }
}));
exports.ImageCarousel = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    [`.${exports.classes.image}`]: {
        width: "100%",
        height: "500px",
        overflow: "hidden",
        "&::after": {
            content: '""',
            display: "block",
            paddingTop: "100%"
        },
        [theme.breakpoints.up("md")]: {
            position: "relative !important",
            width: "auto",
            height: "100%",
            left: 0,
            top: 0,
            maxHeight: "none"
        }
    },
    [theme.breakpoints.up("md")]: {
        position: "absolute",
        top: 0,
        left: "calc(50% + 12px)",
        width: "calc(50vw - 12px)",
        height: `calc(100% - ${horizonHeightMd}px)`,
        maxHeight: "none",
        marginTop: 0
    },
    [theme.breakpoints.up("lg")]: {
        height: `calc(100% - ${horizonHeightLg}px)`
    },
    [theme.breakpoints.up("xl")]: {
        height: `calc(100% - ${horizonHeightXl}px)`,
        "&::after": {
            content: "none"
        }
    }
}));
exports.HorizonContainer = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    [theme.breakpoints.up("md")]: {
        position: "absolute",
        bottom: `${horizonHeightMd}px`,
        width: "100%"
    },
    [theme.breakpoints.up("lg")]: {
        bottom: `${horizonHeightLg}px`
    },
    [theme.breakpoints.up("xl")]: {
        bottom: `${horizonHeightXl}px`
    }
}));
exports.HorizonElement = (0, styles_1.styled)("div")(({ theme }) => ({
    width: "50%",
    background: theme.colours.accent,
    zIndex: 5,
    aspectRatio: `${theme.breakpoints.values.xl / 2}/${horizonHeightLg}`,
    [`&.${exports.horizonClasses.left}`]: {
        clipPath: " polygon(0 0, 100% 0, 0 100%)",
        transform: "translateY(100%)",
        [theme.breakpoints.up("md")]: {
            width: "calc(50% + 30px)"
        }
    },
    [`&.${exports.horizonClasses.right}`]: {
        clipPath: "polygon(100% 0, 100% 100%, 0 100%)"
    }
}));
exports.HorizonWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column-reverse",
        marginTop: "40px"
    }
}));
//# sourceMappingURL=data:application/json;base64,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